module.exports = __webpack_public_path__ + "img/origin.d9743842.svg";